var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarCheckFill = function SvgCalendarCheckFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.8 2.1v1.8h5.4V2.1H17v1.8h3.6a.9.9 0 0 1 .9.9v14.4a.9.9 0 0 1-.9.9H4.4a.9.9 0 0 1-.9-.9V4.8a.9.9 0 0 1 .9-.9H8V2.1zm9.9 6.3H5.3v9.9h14.4zm-4.468 1.922 1.273 1.273-4.455 4.455-3.182-3.183 1.274-1.272 1.909 1.91 3.182-3.183Z"
  })));
};
export default SvgCalendarCheckFill;